export class SignInModel {
    email: string | null = null;
    password: string | null = null;
    mfaCode: string | null = null;
}

export class SignInTokensModel {
    accessToken: string | null = null;
    refreshToken: string | null = null;
}